import Vue from 'vue'
import Router from 'vue-router'
import home from '@/components/home.vue'
import custProject from '@/components/custProject/custProject.vue'
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';


Vue.use(Router)
Vue.use(Loading, {
    color: '#ff6f3c',
    height: 72,
    width: 72,
    backgroundColor: '#000000',
    opacity: 0.1
});

export default new Router({
  mode: 'hash',
  routes: [
    {
      path: '/',
      name: 'home',
      component: home
    },{
      path: '/custProject',
      name: 'custProject',
      component: custProject
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js